import React, { useState } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import s from "./Input.module.scss"

export const Input = ({
  label,
  type,
  onChange,
  value,
  className,
  disabled,
}) => {
  let [focused, setFocused] = useState(false)

  let handleColor = time => {
    return "time-text"
  }

  return (
    <div
      className={`${s.Wrapper} ${focused && s.Wrapper___focused} ${
        className && className
      } ${disabled && s.Wrapper___focused}`}
    >
      <div className={s.Label}>
        <span>{label}</span>
      </div>

      {type == "date" ? (
        <DatePicker
          selected={value && Date.parse(value)}
          onChange={e => onChange(e)}
          dateFormat="d MMMM yyyy "
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      ) : type == "time" ? (
        <DatePicker
          selected={value && Date.parse(value)}
          onChange={e => onChange(e)}
          showTimeSelect
          showTimeSelectOnly
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          timeClassName={handleColor}
          dateFormat="hh:mm a"
        />
      ) : type == "answer" ? (
        <div className={s.Answer}>
          <span>{value && value}</span>
        </div>
      ) : type == "userAnswer" ? (
        <div className={s.UserAnswer}>
          <span>{value && value}</span>
        </div>
      ) : (
        <input
          type={type || "text"}
          value={value && value}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={e => {
            if (!onChange || disabled) return
            onChange(e.target.value)
          }}
        />
      )}
    </div>
  )
}
